import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusStudyRoutingQueryVariables = Types.Exact<{
  studyInstanceUid: Types.Scalars['String'];
}>;


export type EpocusStudyRoutingQuery = { readonly __typename?: 'Query', readonly epocusStudyRouting: { readonly __typename?: 'EpocusStudyRouting', readonly status: Types.EpocusStudyRoutingStatus, readonly receivedAt?: string | null, readonly ingressGateId?: string | null, readonly ingressRouteKey?: string | null, readonly programName?: string | null } };


export const EpocusStudyRoutingDocument = gql`
    query EpocusStudyRouting($studyInstanceUid: String!) {
  epocusStudyRouting(studyInstanceUid: $studyInstanceUid) {
    status
    receivedAt
    ingressGateId
    ingressRouteKey
    programName
  }
}
    `;

/**
 * __useEpocusStudyRoutingQuery__
 *
 * To run a query within a React component, call `useEpocusStudyRoutingQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusStudyRoutingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusStudyRoutingQuery({
 *   variables: {
 *      studyInstanceUid: // value for 'studyInstanceUid'
 *   },
 * });
 */
export function useEpocusStudyRoutingQuery(baseOptions: Apollo.QueryHookOptions<EpocusStudyRoutingQuery, EpocusStudyRoutingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusStudyRoutingQuery, EpocusStudyRoutingQueryVariables>(EpocusStudyRoutingDocument, options);
      }
export function useEpocusStudyRoutingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusStudyRoutingQuery, EpocusStudyRoutingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusStudyRoutingQuery, EpocusStudyRoutingQueryVariables>(EpocusStudyRoutingDocument, options);
        }
export type EpocusStudyRoutingQueryHookResult = ReturnType<typeof useEpocusStudyRoutingQuery>;
export type EpocusStudyRoutingLazyQueryHookResult = ReturnType<typeof useEpocusStudyRoutingLazyQuery>;
export type EpocusStudyRoutingQueryResult = Apollo.QueryResult<EpocusStudyRoutingQuery, EpocusStudyRoutingQueryVariables>;